import { useSyncExternalStore } from 'react';

// #772 part 2 -- Snap to grid is a per-device preference (off by default). #855 -- one shared store,
// so the paper's Snapping popover and the Arrange tab's switch always show the same value.
const SNAP_TO_GRID_KEY = 'peruselab.snapToGrid';

function read(): boolean {
  try {
    return globalThis.localStorage?.getItem(SNAP_TO_GRID_KEY) === 'true';
  } catch {
    return false;
  }
}

let current = read();
const listeners = new Set<() => void>();

export function setSnapToGrid(next: boolean): void {
  if (next === current) return;
  current = next;
  try {
    globalThis.localStorage?.setItem(SNAP_TO_GRID_KEY, String(next));
  } catch {
    // Storage unavailable (private window): the setting lasts for this visit only.
  }
  for (const listener of listeners) listener();
}

export function useSnapToGrid(): readonly [boolean, (next: boolean) => void] {
  const value = useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
    () => false
  );
  return [value, setSnapToGrid] as const;
}
